import { render } from "./HomePage.vue?vue&type=template&id=220e1af9&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=220e1af9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220e1af9"]])

export default __exports__